import React, { Component } from 'react';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import firebase from 'lib/firebase';
import { Container, Col, Row } from 'react-bootstrap';
import ClipLoader from "react-spinners/ClipLoader";
import moment from 'moment';
import axios from 'axios';
import api from 'lib/api';
import global from 'lib/global';
import * as UserActions from 'store/modules/UserModule';


class WorkbookFeedbackItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            fileLoading: false, //피일 업로드중인지
            files: undefined,
        }
    }

    componentDidMount() {
    }

    onChangeMessage = (e) => {
        this.setState({ message: e.target.value });
    }

    handleAttachFile = (e) => {
        this.setState({ files: e.target.files });
    }

    onClickFeedbackSend = () => {
        this.uploadImage(this.state.files);
    }

    uploadImage = async (files) => {
        if (this.state.fileLoading) {
            return;
        }

        const { item, index } = this.props;
        let list = this.props.adminWorkbookList.list[index];
        const code = list.code;

        if (!this.state.message || this.state.message.length == 0) {
            alert("메모를 입력해주세요");
            return;
        }
        if (!files || files.length == 0) {
            alert("파일을 첨부해주세요");
            return;
        }

        const self = this;

        const url = global.url_api + '/workbook/fileUpload/tutorUpload';
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }
        formData.append('code', code);
        formData.append('message', this.state.message);

        var user = firebase.auth().currentUser;
        let token = await user.getIdToken()

        const config = {
            headers: {
                'accept': 'application/json',
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Authorization': token
            }
        }

        this.setState({ fileLoading: true });
        axios.post(url, formData, config)
            .then(function (response) {

                self.setState({ fileLoading: false });
                let data = response.data;
                if (data.result) {
                    //성공
                    self.props.onRefreshList();
                    self.setState({ message: ''});
                    document.getElementById('file').value = "";
                } else {
                    //실패
                    alert("실패했습니다.");
                }
            })
            .catch(function (err) {
                self.setState({ fileLoading: false });
            })
    };

    render() {
        const { item } = this.props;

        if (item.get_type != 0 && item.edit_type == 0) {
            return (
                <div id='feedback' className='expandRowContainer'>
                    <Row>
                        <Col md={10}>
                            <div className='userInfoContainer'>
                                <p style={{ color: "#e9532e", margin: 0 }}>From. {item.email}</p>
                                <p style={{ color: "#444", margin: 0 }}>{item.message}</p>
                            </div>
                            <textarea
                                id="memo"
                                placeholder="memo"
                                onChange={(e) => this.onChangeMessage(e)} />
                            <input id="file" type="file" multiple style={{ color: '#666' }}
                                onChange={(e) => this.handleAttachFile(e)} />
                        </Col>
                        <Col md={2} className="my-auto" style={{ textAlign: 'center' }}>
                            <a className='buttonSave'
                                onClick={() => this.onClickFeedbackSend()}
                                style={this.state.fileLoading == true ? { display: 'none' } : { display: 'default', backgroundColor: '#ff7a59', color: '#fff' }} >Upload</a>
                            <ClipLoader
                                loader={"FadeLoader"}
                                color={'#0013c0'}
                                loading={this.state.fileLoading}
                                css={{ display: 'block', margin: '4.5% auto' }}
                                size={30}
                                className={"loader"}
                            />
                        </Col>
                    </Row>
                </div>
            );
        } else {
            return (
                <div id='feedback' className='expandRowContainer'>
                    <div className='noFeedback'>피드백 파일전송 불가</div>
                </div>
            )
        }
    }
}



let mapStateToProps = (state) => ({
    adminWorkbookList: JSON.parse(JSON.stringify(state.AdminModule.get('adminWorkbookList'))),
});

let mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkbookFeedbackItem);

